import { render } from "./FormaEntregaCadastro.vue?vue&type=template&id=ef4aafa6&scoped=true&ts=true"
import script from "./FormaEntregaCadastro.vue?vue&type=script&lang=ts"
export * from "./FormaEntregaCadastro.vue?vue&type=script&lang=ts"

import "./FormaEntregaCadastro.vue?vue&type=style&index=0&id=ef4aafa6&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4aafa6"]])

export default __exports__